import { FC } from 'react';

import { Spinner, SpinnerContainer } from './styled';

const sizes = {
  small: 16,
  medium: 24,
  large: 36,
  extraLarge: 64
};

type LoaderSize = keyof typeof sizes;

type Props = {
  size?: LoaderSize;
};

export const Loader: FC<Props> = ({ size = 'medium' }) => {
  return (
    <SpinnerContainer data-testid="loader">
      <Spinner $size={sizes[size]} />
    </SpinnerContainer>
  );
};
